const stagingLinks = {
  en: {
    formsUrl: 'https://www.audi.ca/ca/web/en/forms/trade-in-staging.html',
  },
  fr: {
    formsUrl: 'https://www.audi.ca/ca/web/fr/forms/trade-in-staging.html',
  },
  paymentEstimator: {
    url: 'https://staging.audipaymentestimator.ca/',
  },
  contactDealer: {
    url: '/contact-dealer-uc-staging.html',
  },
};

export default stagingLinks;
